import bg from '../images/home1.jpg'  //在根目录下 src图片用 import引
let cardData=[
  {title:'第一天',desc:'第一天描述',url:'a'},
  {title:'第二天',desc:'第二天描述',url:'b'},
  {title:'第三天',desc:'第三天描述',url:'c'},
  {title:'第四天',desc:'第四天描述',url:'d'},
  {title:'第五天',desc:'第五天描述',url:'e'}
]
export {cardData}



/** WEBPACK FOOTER **
 ** src/data.js
 **/